import { InputNumber } from "antd";
import React, { useEffect, useState } from "react";
import { $t } from "~/i18n.js";

export const TacometerInput = ({ motor_format, value, readOnly, onChange}) => {
  const [hours, setHours] = useState(0);
  const [minutes, setMinutes] = useState(0);
  const [seconds, setSeconds] = useState(0);
  const [decimalHours, setDecimalHours] = useState(0);

  // Convert decimal minutes to hours, minutes, seconds and decimal hours when value changes
  useEffect(() => {
    if (value !== undefined && value !== null) {
      const totalMinutes = parseFloat(value) || 0;
      const totalSeconds = totalMinutes * 60;
      const h = Math.floor(totalSeconds / 3600);
      const m = Math.floor((totalSeconds % 3600) / 60);
      const s = Math.floor(totalSeconds % 60);
      setHours(h);
      setMinutes(m);
      setSeconds(s);
      setDecimalHours(totalMinutes / 60);
    }
  }, [value]);

  // Handle decimal hours input
  const handleDecimalChange = (newValue) => {
    if (newValue !== null && newValue !== undefined) {
      
      setDecimalHours(newValue);
      const totalMinutes = newValue * 60;
      onChange && onChange(totalMinutes);
    }
  };

  // Handle hours input for HH:MM(:SS) format
  const handleHoursChange = (newHours) => {
    if (newHours !== null && newHours !== undefined) {
      const totalSeconds = (newHours * 3600) + (minutes * 60) + seconds;
      const totalMinutes = totalSeconds / 60;
      
      setHours(newHours);
      onChange && onChange(totalMinutes);
    }
  };

  // Handle minutes input for HH:MM(:SS) format
  const handleMinutesChange = (newMinutes) => {
    if (newMinutes !== null && newMinutes !== undefined) {
      // Cycle minutes: if >= 60, reset to 0; if < 0, set to 59
      let validMinutes = newMinutes;
      if (newMinutes >= 60) {
        validMinutes = 0;
      } else if (newMinutes < 0) {
        validMinutes = 59;
      }
      
      const totalSeconds = (hours * 3600) + (validMinutes * 60) + seconds;
      const totalMinutes = totalSeconds / 60;
      
      setMinutes(validMinutes);
      onChange && onChange(totalMinutes);
    }
  };

  // Handle seconds input for HH:MM:SS format
  const handleSecondsChange = (newSeconds) => {
    if (newSeconds !== null && newSeconds !== undefined) {
      // Cycle seconds: if >= 60, reset to 0; if < 0, set to 59
      let validSeconds = newSeconds;
      if (newSeconds >= 60) {
        validSeconds = 0;
      } else if (newSeconds < 0) {
        validSeconds = 59;
      }
      
      const totalSeconds = (hours * 3600) + (minutes * 60) + validSeconds;
      const totalMinutes = totalSeconds / 60;
      
      setSeconds(validSeconds);
      onChange && onChange(totalMinutes);
    }
  };

  if (motor_format === "decimal") {
    return (
      <InputNumber
        value={decimalHours}
        onChange={handleDecimalChange}
        readOnly={readOnly}
        disabled={readOnly}
        variant={readOnly ? "borderless" : undefined}
        min={0}
        step={0.01}
        precision={3}
        style={{ width: 150 }}
        placeholder="0.00"
        addonAfter={$t("uren")}
      />
    );
  }

  // HH:MM:SS format
  return (
    <div className="row" style={{ gap: 6, alignItems: "center" }}>
      <InputNumber
        value={hours}
        onChange={handleHoursChange}
        readOnly={readOnly}
        variant={readOnly ? "borderless" : undefined}
        disabled={readOnly}
        min={0}
        style={{ width: 100 }}
        placeholder="0"
        addonAfter={$t('uur')}
      />
      <span>{" "}</span>
      <InputNumber
        value={minutes}
        onChange={handleMinutesChange}
        readOnly={readOnly}
        variant={readOnly ? "borderless" : undefined}
        disabled={readOnly}
        style={{ width: 100 }}
        placeholder="00"
        addonAfter={$t('min')}
      />
      <span>{" "}</span>
      {motor_format === "hhmmss" && (
        <InputNumber
        value={seconds}
        onChange={handleSecondsChange}
        readOnly={readOnly}
        variant={readOnly ? "borderless" : undefined}
        disabled={readOnly}
        style={{ width: 100 }}
        placeholder="00"
        addonAfter={$t('sec')}
      />
    )}
    </div>
  );
};
